import { toFont } from 'chart.js/helpers'

// Chart.js plugin that ellipsizes (truncates) the row labels of a horizontal chart to the
// width the layout actually grants the category axis.
export const EllipsizeTicksPlugin = {
    id: 'ellipsizeTicks',

    beforeInit(chart) {
        EllipsizeTicksPlugin.beforeUpdate(chart)
    },

    beforeUpdate(chart) {
        if (chart.options.indexAxis !== 'y') return
        const scales = chart.options.scales
        if (!scales) return

        scales.y ??= {}
        scales.y.ticks ??= {}
        scales.y.ticks.callback = ellipsizeTickCallback
    },
}

// The category scale's ticks.callback: binary-search the longest prefix whose
// rendered width (plus the ellipsis) fits this.maxWidth — the pixel budget the
// layout just granted the axis.
function ellipsizeTickCallback(value) {
    const label = this.getLabelForValue(value)
    if (typeof label !== 'string' || !label) return label
    const { ctx } = this.chart
    ctx.font = toFont(this.options.ticks.font).string
    const budget = this.maxWidth - (this.options.ticks.padding ?? 3) - 4
    if (ctx.measureText(label).width <= budget) return label
    let low = 1
    let high = label.length - 1
    let fit = 1
    while (low <= high) {
        const mid = (low + high) >> 1
        if (ctx.measureText(`${label.slice(0, mid).trimEnd()}…`).width <= budget) {
            fit = mid
            low = mid + 1
        } else {
            high = mid - 1
        }
    }
    return `${label.slice(0, fit).trimEnd()}…`
}
